import action from 'app/lib/action';
import {STORE_GOOD} from '../constants/actionTypes';

export default {
    request : (utrac, formData) => action(STORE_GOOD.REQUEST)({utrac, formData}),
    success : (good) => action(STORE_GOOD.SUCCESS)({good}),
    error   : (error) => action(STORE_GOOD.ERROR)({error})
};